import { FilingDocument } from '../../../molecules/filings/overview/FilingDocument';
import { IIndirectTaxFilingDocument } from '../types';

interface IndirectTaxFilingDetailDocumentsListProps {
  filingConfirmationDocuments: IIndirectTaxFilingDocument[];
  relatedDocuments: IIndirectTaxFilingDocument[];
}

const IndirectTaxFilingDetailDocumentsList = ({
  filingConfirmationDocuments,
  relatedDocuments,
}: IndirectTaxFilingDetailDocumentsListProps) => {
  if (filingConfirmationDocuments.length === 0 && relatedDocuments.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-xl">
      {filingConfirmationDocuments.length > 0 && (
        <div className="flex flex-col gap-xl">
          <span className="txt-medium-bold text-text-primary">
            Filing confirmation
          </span>
          {filingConfirmationDocuments.map((doc) => (
            <FilingDocument key={doc.fileName} file={doc} />
          ))}
        </div>
      )}

      {relatedDocuments.length > 0 && (
        <div className="flex flex-col gap-xl">
          <span className="txt-medium-bold text-text-primary">
            Related documents
          </span>
          {relatedDocuments.map((doc) => (
            <FilingDocument key={doc.fileName} file={doc} />
          ))}
        </div>
      )}
    </div>
  );
};

export { IndirectTaxFilingDetailDocumentsList };
